
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kkk",
      function () {
        return require("private-next-pages/kkk/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kkk"])
      });
    }
  